module.exports = __webpack_public_path__ + "img/Comic08-1.ead152bf.png";